import request from "../../utils/request";
const Authorization = localStorage.getItem("Authorization");
/*
 * @Author: The Jin
 * @Date: 2023-03-09 14:03
 * @FilePath: \appletd:\projects\mgr_web\src\api\sciptLibrary\index.js
 * @Description: 话术库api
 * @LastEditors: Do not edit
 * @LastEditTime: 2025-01-15 09:15:11
 * @LastDescription:
 */
// 查询所有一级分类
export function getOneClass(isLoading) {
  return request(
    {
      url: "/api/qywechat/script/one_class/all",
      method: "get",
      headers: {
        authorization: Authorization,
      },
    },
    isLoading
  );
}
// 查询一级分类下的二级分类
export function getTwoClass(oneClassId, isLoading) {
  return request(
    {
      url: `api/qywechat/script/two_class/${oneClassId}`,
      method: "get",
      headers: {
        authorization: Authorization,
      },
    },
    isLoading
  );
}
// 话术列表
export function getList(params, isLoading) {
  return request(
    {
      url: "api/qywechat/script",
      method: "get",
      params,
      headers: {
        authorization: Authorization,
      },
    },
    isLoading
  );
}
// 删除一条话术
export function deleteScript(scriptId, isLoading) {
  return request(
    {
      url: `api/qywechat/script/${scriptId}`,
      method: "delete",
      headers: {
        authorization: Authorization,
      },
    },
    isLoading
  );
}
// 编辑-获取详情(旧) 后端合并代码导致侧边栏接口和后台接口冲突，所以废弃
// export function getScript(scriptId, isLoading) {
//   return request(
//     {
//       url: `api/qywechat/script/${scriptId}`,
//       method: "get",
//       headers: {
//         authorization: Authorization,
//       },
//     },
//     isLoading
//   );
// }
export function getScriptAdmin(scriptId, isLoading) {
  return request(
    {
      url: `api/qywechat/script/admin/${scriptId}`,
      method: "get",
      headers: {
        authorization: Authorization,
      },
    },
    isLoading
  );
}
// 编辑一条话术
export function editScript(scriptId, data, isLoading) {
  return request(
    {
      url: `api/qywechat/script/${scriptId}`,
      method: "put",
      data,
      headers: {
        authorization: Authorization,
      },
    },
    isLoading
  );
}
// 新建一条话术
export function addScript(data, isLoading) {
  return request(
    {
      url: `api/qywechat/script`,
      method: "post",
      data,
      headers: {
        authorization: Authorization,
      },
    },
    isLoading
  );
}
// 导入话术
export function importData(data, isLoading) {
  return request(
    {
      url: `/api/qywechat/script/excel_import`,
      method: "post",
      data,
      headers: {
        authorization: Authorization,
        "Content-Type": "multipart/form-data",
      },
    },
    isLoading
  );
}
// 话术分类树
export function getTree( isLoading) {
  return request(
    {
      url: `api/qywechat/script/oneClass/list`,
      method: "get",
      headers: {
        authorization: Authorization,
      },
    },
    isLoading
  );
}
// 新增一级分类
export function addOneClass(data, isLoading) {
  return request(
    {
      url: `/api/qywechat/script/one_class`,
      method: "post",
      data,
      headers: {
        authorization: Authorization,
      },
    },
    isLoading
  );
}
// 新增二级分类
export function addTwoClass(data, isLoading) {
  return request(
    {
      url: `/api/qywechat/script/two_class`,
      method: "post",
      data,
      headers: {
        authorization: Authorization,
      },
    },
    isLoading
  );
}
// 编辑二级分类
export function editTwoClass(classId,data, isLoading) {
  return request(
    {
      url: `/api/qywechat/script/two_class/${classId}`,
      method: "put",
      data,
      headers: {
        authorization: Authorization,
      },
    },
    isLoading
  );
}
// 编辑一级分类  
export function editOneClass(classId,data, isLoading) {
  return request(
    {
      url: `/api/qywechat/script/one_class/${classId}`,
      method: "put",
      data,
      headers: {
        authorization: Authorization,
      },
    },
    isLoading
  );
}
// 删除一级 二级分类  api=two_class、one_class
export function deleteOneClass(apiName,classId, isLoading) {
  return request(
    {
      url: `/api/qywechat/script/${apiName}/${classId}`,
      method: "delete",
      headers: {
        authorization: Authorization,
      },
    },
    isLoading
  );
}
// 一级分类拖拽排序
export function dragOneClass(data, isLoading) {
  return request(
    {
      url: `/api/qywechat/script/one_class/position`,
      method: "put",
      data,
      headers: {
        authorization: Authorization,
      },
    },
    isLoading
  );
}
// 二级分类拖拽排序
export function dragtwoClass(data, isLoading) {
  return request(
    {
      url: `/api/qywechat/script/two_class/position`,
      method: "put",
      data,
      headers: {
        authorization: Authorization,
      },
    },
    isLoading
  );
}
// 查询所有分类（话术库-树形列表）
export function selectAllClass(params) {
  return request({
    url: "/api/qywechat/script/class/selectAll",
    method: "get",
    params,
    headers: {
      authorization: Authorization,
    },
  });
}
// 保存分类（话术库-新增/修改/删除统一接口）
export function saveClass(params) {
  return request({
    url: "/api/qywechat/script/class/save",
    method: "post",
    data: params,
    headers: {
      authorization: Authorization,
    },
  });
}

/** 侧边栏-话术库-获取分类列表(1-一级 2-二级 3-三级, 一级parentId传-1) */
export function getClassApi(data, isLoading) {
  return request({
    url: `/api/qywechat/script/class/selectSub`,
    method: 'GET',
    params: data,
  }, isLoading)
}